import { Request } from 'api';
import { AxiosResponse } from 'axios';

export interface PhoneResendSMSResponse {
    message: string;
}

type ReturnType = Promise<AxiosResponse<PhoneResendSMSResponse>>;

const userResendSMSCode = (phone: string): ReturnType => {
    return Request.post(`/authentication/sms/resend-code`, { phone });
};

export default userResendSMSCode;
